import { Box } from '@mui/material';
import { FontSizes } from '../../../../constants/font-sizes';
import { Colors } from '../../../../constants/colors';
import React, { useEffect, useState } from 'react';
import { showAllTagName } from '../../constant';

interface Props {
  policyData: any[];
  selectedTag: string;
  setSelectedTag: (tag: string) => void;
}

export const PolicyTags = ({
  policyData,
  selectedTag,
  setSelectedTag,
}: Props) => {
  const [tagMap, setTagMap] = useState<Map<string, number>>(new Map());

  useEffect(() => {
    generateTagDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policyData]);

  /* Generate Map for the Tags with their associated policies */
  const generateTagDetails = (): void => {
    const tagList: Map<string, number> = new Map();
    tagList.set(showAllTagName, policyData?.length ? policyData.length : 0);
    policyData?.forEach((policy: any) => {
      const tags: string[] = policy.tags;
      tags?.forEach((tag: string) => {
        if (tagList.has(tag)) {
          let policyCount = tagList.get(tag);
          // @ts-ignore
          tagList.set(tag, ++policyCount);
        } else {
          tagList.set(tag, 1);
        }
      });
    });
    setTagMap(tagList);
  };

  return (
    <>
      <Box sx={{ display: 'flex', marginBottom: '15px' }} flexWrap="wrap">
        {Array.from(tagMap.entries()).map(([key, value]) => (
          <Box
            key={key}
            sx={{
              fontWeight: '500',
              fontSize: FontSizes.fontSize13,
              lineHeight: '16px',
              color: `${
                key === selectedTag ? Colors.white : Colors.blackPearl
              }`,
              border: `1px solid ${
                key === selectedTag ? Colors.white : Colors.blackPearl
              }`,
              borderRadius: '100px',
              cursor: 'pointer',
              margin: '10px',
              background: `${
                key === selectedTag
                  ? Colors.tabGradient
                  : Colors.whiteTransparent07
              }`,
            }}
            display="inline-flex"
            whiteSpace="nowrap"
            textAlign="center"
            paddingY={0.5}
            paddingX={1}
            onClick={() => setSelectedTag(key)}
          >
            {`${key} (${value})`}
          </Box>
        ))}
      </Box>
    </>
  );
};
